<template>
  <el-card>
   <el-form :model="info" ref="info" label-width="80px" class="global-form2">
     <el-form-item label="姓名" prop="userName">
       <p>{{info.userName || ''}}</p>
     </el-form-item>
     <el-form-item label="所属组织" prop="deptName">
       <p>{{info.deptName || ''}}</p>
     </el-form-item>
     <el-form-item label="角色" prop="roleName">
       <p>{{info.roleName || ''}}</p>
     </el-form-item>
     <el-form-item label="手机号码" prop="mobile">
       <p>{{info.mobile || ''}}</p>
     </el-form-item>
     <el-form-item label="登录账号" prop="loginId">
       <p>{{info.loginId || ''}}</p>
     </el-form-item>
     <el-form-item label="关联项目" prop="loginId">
       <div v-if="info.dataPermission !== '1'">
         <div class="projectList" v-if="projectCheckList && projectCheckList.length">
           <p v-for="(item, index) in projectCheckList" :key="index">{{item.projectName}}</p>
         </div>
       </div>
       <div v-else>全部数据</div>
     </el-form-item>
   </el-form>
 </el-card>
</template>

<script>
export default {
  name: 'PersonnelDetail',
  data () {
    return {
      info: {},
      projectCheckList: []
    }
  },
  created () {
    this.getInfo()
    this.projectCurrent()
  },
  methods: {
    getInfo () {
      this.$axios.get(this.$apis.system.personnelDetail, {
        userId: this.$route.params.id
      }).then((res) => {
        this.info = res
      })
    },
    projectCurrent () {
      this.$axios.get(this.$apis.project.selectJgProjectAllByList, {
        userId: this.$route.params.id
      }).then(res => {
        this.projectCheckList = res
      })
    }
  }
}
</script>

<style scoped lang='scss'>
 .el-card {
   display: flex;
 }
 .projectList {
   flex: 1;
   width: auto;
   min-width: 280px;
   max-height: 266px;
   padding: 10px;
   background: #FAFAFA;
   border-radius: 2px;
   overflow-y: auto;
   p {
     font-size: 14px;
     font-family: PingFangSC-Regular, PingFang SC;
     font-weight: 400;
     color: #666666;
     line-height: 22px;
     margin-bottom: 10px;
   }
 }

</style>
